<template>
  <div>
    <div
      class="row"
    >
      <div
        class="col-12"
      >
        <h1
          class="page-title pl-3"
          v-text="__('Integrações')"
        />
      </div>
    </div>

    <div
      class="row"
    >
      <div
        class="col-12 d-flex align-items-baseline"
      >
        <h2
          class="page-subtitle pl-3"
          v-text="__('Veja as integrações disponíveis')"
        />
      </div>
    </div>
    <div
      class="row board board-container table-responsive mt-2"
    >
      <div
        class="col-md-12 px-0"
      >
        <div
          class="d-flex"
        >
          <div
            class="menu bg-salesflow-bg-content"
          >
            <div
              class="mx-32px"
            >
              <div
                class="bdk-flex bdk-items-center bdk-my-8"
              >
                <input
                  type="text"
                  v-model="search"
                  class="search-input form-control"
                  :placeholder="__('Encontre uma categoria')"
                >

                <Search class="icon-search" />
              </div>

              <h5
                class="categories"
                v-text="__('Categorias')"
                v-if="categories.length > 0"
              />

              <ul
                class="list-group"
              >
                <li
                  :key="category"
                  v-for="category in categories"
                  class="list-group-item border-0 bg-salesflow-bg-content bdk-flex bdk-items-center"
                  @click="search === category ? search = '' : search = category"
                  :class="{
                    'bdk-order-first': category === 'Bulldesk',
                    'bdk-text-indigo-600': search.toLowerCase() === category.toLowerCase(),
                  }"
                >
                  <strong class="category"
                    v-text="__(category)"
                  />

                  <div
                    class="bdk-ml-auto"
                    v-if="search.toLowerCase() === category.toLowerCase()"
                  >
                    <svg class="bdk-h-4 bdk-w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="list-integration"
          >
            <div
              v-if="categories.length > 0"
              class="list-integration-wrapper"
            >
              <div
                :key="category"
                class="list-category"
                v-for="category in categories"
                :class="{ 'bdk-order-first': category === 'Bulldesk'}"
              >
                <h5
                  class="title-category"
                  v-text="__(category)"
                />

                <div
                  class="d-flex flex-wrap"
                >
                  <div
                    :key="integration.key"
                    v-for="integration in integrations"
                  >
                    <div
                      v-if="category === integration.category"
                    >
                      <a
                        class="card-link"
                        :href="'/integrations/' + integration.key"
                      >
                        <div
                          class="card-integration mr-32px mt-3 bg-white"
                        >
                          <div
                            class="card-integration-body d-flex justify-content-center align-items-center"
                          >
                            <img
                              :src="integration.logo"
                              :alt="integration.name"
                              class="bdk-h-auto"
                              :width="integration.width ? integration.width : '58%'"
                            >

                            <button
                              v-text="__('Integrar')"
                              class="integrate-button salesflow-btn salesflow-btn-primary"
                            />
                            <span 
                              v-if="integration.new"
                              class="new-badge"
                              v-text="__('Novo')"
                            />
                          </div>

                          <div class="card-integration-footer d-flex">
                            <div class="card-integration-div d-flex">
                              <span v-if="'activeIntegration' in integration" class="d-inline-block rounded-circle card-integration-icon"
                              :class="{'active': integration.activeIntegration, 'inactive': !integration.activeIntegration}"
                              v-b-tooltip.hover.html="integration.activeIntegration ? 'Integrado' : 'Integração pendente'"></span>
                            </div>
                            <div class="col-md-12 p-0 d-flex justify-content-center align-items-center card-integration-text">
                              <span v-text="__(integration.name)"></span>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else
              class="noCategories text-center"
            >
              <div
                class="d-flex flex-column justify-content-center bdk-w-full"
              >
                <i
                  class="fa fa-star-o icon-title"
                />

                <h1
                  class="title-noCategories"
                  v-text="__('Nenhuma categoria encontrada')"
                />

                <h2
                  class="subtitle-noCategories"
                  v-text="__('Refaça sua busca com outros termos.')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '../icon/Search';
import { VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    Search,
  },

  directives: {
    'b-tooltip': VBTooltip
  },

  props: {
    integrations: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    search: '',
  }),

  computed: {
    categories () {
      const {
        search,
        integrations,
      } = this;

      const sortedCategories = Object.keys(integrations).map(key => this.integrations[key].category).sort();

      sortedCategories.unshift('Salesflow');

      const categories = new Set(
        sortedCategories
      );

      return [...categories].filter(category => category.toLowerCase().includes(search.toLowerCase()));
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  h5 {
    font-size: 16px;
  }

  .list-group-item {
    @include salesflow-text(
      $line-height: 130%,
      $font-weight: 600
    );
  }

  .list-group-item.border-0 {
    padding: 11px 10px 11px 0px;
  }

  .card-link:hover {
    cursor: default;
  }

  .list-group-item.border-0:hover {
    cursor: pointer;
    color: $salesflow-font-purple-light;
  }

  .card-integration:hover, .category-active {
    color: $salesflow-font-purple-light;
    cursor: default;

    .card-integration-footer {
      color: $white;
      background-color: $salesflow-primary;
    }
  }

  .integrate-button {
    border-radius: 16px;
  }

  .integrate-button:hover {
    background: $salesflow-primary-hover !important;
    color: $white;
  }

  h5.categories {
    @include salesflow-subtitle(
      $font-weight: 600,
      $color: $salesflow-font-gray,
      $line-height: 130%
    );
  }

  .card-integration {
    width: 232px;
    height: 132px;
    border-radius: 16px;
    border: 1px solid $salesflow-outline-gray-light;
    background-color: $white;
    box-shadow: 0px 8px 24px 0px #0000001A;
  }

  .card-integration-body {
    width: 100%;
    height: 70%;
    padding: 8px 12px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .card-integration-body img {
    transition: margin-top 0.2s ease;
  }

  .card-integration-body:has(.new-badge) img {
    margin-top: 33px;
  }

  .card-integration:hover {
    .card-integration-body img {
      margin-top: 0;
    }

    .new-badge {
      display: none;
    }
  }

  .list-integration-wrapper {
    display: flex;
    flex-flow: column nowrap;
    margin-top: 56px;
  }

  .card-link  button {
    display: none;
  }

  .card-integration:hover img {
    display: none;
  }

  .card-integration:hover button {
    display: inline;
  }

  .card-integration-footer{
    position:relative;
    background: $white;
    width: 100%;
    height: 30%;
    border-top: 1px solid $salesflow-outline-gray-light;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    padding: 8px 0px;
    @include salesflow-text(
      $color: $salesflow-font-purple-light,
      $font-weight: 600
    );
  }

  .category-active {
    border-radius: 8px;
  }

  .list-integration, .search-integration, .board-container, .category-active {
    background: $white;
  }

  .category {
    @include salesflow-text(
      $font-weight: 600,
      $line-height: 130%
    );
  }

  .list-integration {
    flex-grow: 1;
  }

  .search-input {
    background-color: $white;
    padding: 7px 12px;
    border-radius: 5px;
    outline: 1px solid $salesflow-outline-gray-medium;
    @include salesflow-text(
      $font-weight: 500,
      $color: $salesflow-font-dark
    );
  }

  .board-container {
    min-height: 800px;
  }

  .icon-search {
    margin-left: -35px;
  }

  .list-category {
    margin-bottom: 43px;
    margin-left: 27px;
  }

  .title-category {
    @include salesflow-subtitle(
      $font-weight: 600
    );
  }

  .menu {
    min-width: 288px;
    min-height: 800px;
  }

  .icon-title {
    font-size: 55px;
    color: #789;
  }

  .noCategories {
    flex-grow: 1;
    padding: 30px;
  }

  .title-noCategories {
    font-size: 24px;
    color: #878787;
  }

  .subtitle-noCategories {
    font-size: 18px;
    color: #777777
  }

  .mx-32px {
    margin-left: 32px;
    margin-right: 32px;
  }
  .active {
    background-color: $salesflow-success;
  }

  .inactive {
    background-color: $salesflow-outline-gray-light;
  }

  .card-integration-div {
    margin-left: 12px;
    margin-top: 8px;
  }

  .card-integration-icon {
    width: 8px;
    height: 8px;
    z-index: 9999;
  }

  .card-integration-text{
    margin-left:-20px;
  }

  .new-badge {
    position: absolute;
    top: 10px;
    right: 50px;
    display: flex;
    padding: 4.2px 7.8px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: #04D29C;
    font-size: 12px;
    z-index: 1;
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
  }
</style>
